import React from 'react'
import Banner from './Banner'
import AboutContent from './AboutContent'
import AboutStatics from './AboutStatics'
import MeetOur from './MeetOur'

export default function AboutUs() {
  return (
    <main>
        <Banner/>
        <AboutContent/>
        <AboutStatics/>
        <MeetOur/>
    </main>
  )
}
